<!--
    <nav class="navbar navbar-expand bg-light">
        <div class="container"><a class="navbar-brand" href="#">Price Matcher</a>
            <button data-bs-toggle="collapse" class="navbar-toggler" data-bs-target="#navcol-1"></button>
            <div class="collapse navbar-collapse" id="navcol-1">
                <a class="btn btn-primary ms-auto" role="button" [routerLink]="['/search']">Web app</a>
            </div>

           
        </div>
    </nav>
    
    <header class="text-center text-white masthead" style="background:url('https://lnading-page-assets.s3.us-west-1.amazonaws.com/price-matcher/assets/img/bg-masthead.jpg')no-repeat center center;background-size:cover;">
        <div class="overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-xl-9 mx-auto position-relative">
                    <h1 class="mb-5"><span style="font-weight: normal !important; background-color: rgba(31, 31, 31, 0);">Find the Best Price in Seconds! Compare Prices Across Multiple Platforms.</span></h1>
                </div>
                <div class="col-md-10 col-lg-8 col-xl-7 mx-auto position-relative">
                    <div style="width: 100%;">
                        <a class="btn btn-primary ms-auto" role="button" href="https://play.google.com/apps/internaltest/4701150229991970065">Android testing</a>
                    </div>

                </div>
            </div>
        </div>
    </header>
    -->
<section class="text-center bg-#121212 features-icons">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="mx-auto features-icons-item mb-5 mb-lg-0 mb-lg-3">
                    <div class="d-flex features-icons-icon"><svg xmlns="http://www.w3.org/2000/svg"
                            enable-background="new 0 0 24 24" height="1em" viewBox="0 0 24 24" width="1em"
                            fill="currentColor" class="m-auto text-primary" data-bss-hover-animate="pulse"
                            style="font-size: 95px;">
                            <rect fill="none" height="24" width="24"></rect>
                            <g>
                                <path
                                    d="M14.06,9.94L13,9.45c-0.39-0.18-0.39-0.73,0-0.91l1.06-0.49L14.55,7c0.18-0.39,0.73-0.39,0.91,0l0.49,1.06L17,8.55 c0.39,0.18,0.39,0.73,0,0.91l-1.06,0.49L15.45,11c-0.18,0.39-0.73,0.39-0.91,0L14.06,9.94z M4.45,13l0.49-1.06L6,11.45 c0.39-0.18,0.39-0.73,0-0.91l-1.06-0.49L4.45,9C4.28,8.61,3.72,8.61,3.55,9l-0.49,1.06L2,10.55c-0.39,0.18-0.39,0.73,0,0.91 l1.06,0.49L3.55,13C3.72,13.39,4.28,13.39,4.45,13z M8.96,7.99l0.63-1.4l1.4-0.63c0.39-0.18,0.39-0.73,0-0.91l-1.4-0.63l-0.63-1.4 c-0.18-0.39-0.73-0.39-0.91,0l-0.63,1.4l-1.4,0.63c-0.39,0.18-0.39,0.73,0,0.91l1.4,0.63l0.63,1.4C8.22,8.38,8.78,8.38,8.96,7.99z M22.34,8.27c-0.4-0.4-1.07-0.39-1.45,0.04l-6.39,7.18l-3.29-3.29c-0.39-0.39-1.02-0.39-1.41,0l-6.04,6.05 c-0.41,0.41-0.41,1.09,0,1.5c0.41,0.41,1.09,0.41,1.5,0l5.25-5.26l3.25,3.25c0.41,0.41,1.07,0.39,1.45-0.04l7.17-8.07 C22.73,9.24,22.71,8.64,22.34,8.27z">
                                </path>
                            </g>
                        </svg></div>
                    <h3><span>Price Comparison Across Multiple Platforms</span></h3>
                    <p class="lead mb-0"><span>Instantly compare prices from several platforms in one place.</span></p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="mx-auto features-icons-item mb-5 mb-lg-0 mb-lg-3">
                    <div class="d-flex features-icons-icon"><svg xmlns="http://www.w3.org/2000/svg" height="1em"
                            viewBox="0 0 24 24" width="1em" fill="currentColor" class="m-auto text-primary"
                            data-bss-hover-animate="pulse" style="font-size: 95px;">
                            <path d="M0 0h24v24H0V0z" fill="none"></path>
                            <path
                                d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54V4.5c0-.83-.67-1.5-1.5-1.5S10 3.67 10 4.5v.66c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z">
                            </path>
                        </svg></div>
                    <h3><span>Save Time and Money</span></h3>
                    <p class="lead mb-0"><span>No more jumping between tabs or visiting different websites—get
                            everything you need in one quick scan/search!</span></p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="mx-auto features-icons-item mb-5 mb-lg-0 mb-lg-3">
                    <div class="d-flex features-icons-icon"><svg xmlns="http://www.w3.org/2000/svg"
                            enable-background="new 0 0 24 24" height="1em" viewBox="0 0 24 24" width="1em"
                            fill="currentColor" class="m-auto text-primary" data-bss-hover-animate="pulse"
                            style="font-size: 95px;">
                            <g>
                                <path d="M0,0h24v24H0V0z" fill="none"></path>
                            </g>
                            <g>
                                <path
                                    d="M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M16,16 c-0.39,0.39-1.02,0.39-1.41,0l-3.29-3.29C11.11,12.52,11,12.27,11,12V8c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v3.59l3,3 C16.39,14.98,16.39,15.61,16,16z">
                                </path>
                            </g>
                        </svg></div>
                    <h3><span>Easy to Use</span></h3>
                    <p class="lead mb-0"><span>Easy to use! just a quick scan or search!</span></p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="showcase">
    <div class="container-fluid p-0">
        <div class="row g-0">
            <div class="col-lg-6 text-white order-lg-2 showcase-img"
                style="background-image:url(&quot;https://lnading-page-assets.s3.us-west-1.amazonaws.com/price-matcher/assets/img/scan-action.png&quot;);">
                <span></span></div>
            <div class="col-lg-6 my-auto order-lg-1 showcase-text">
                <h2>Scan or Search products</h2>
                <p class="lead mb-0">Scan product barcode or manually enter product upc code. Product can also be
                    searched by description.</p>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 text-white showcase-img"
                style="background-image:url(&quot;https://lnading-page-assets.s3.us-west-1.amazonaws.com/price-matcher/assets/img/compare-pic.png&quot;);">
                <span></span></div>
            <div class="col-lg-6 my-auto order-lg-1 showcase-text">
                <h2>View product and price ranges&nbsp;</h2>
                <p class="lead mb-0">Products from multiple platforms can be viewed&nbsp; along with their prices and
                    price ranges.</p>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 text-white order-lg-2 showcase-img"
                style="background-image:url(&quot;https://lnading-page-assets.s3.us-west-1.amazonaws.com/price-matcher/assets/img/calculator.jpg&quot;);">
                <span></span></div>
            <div class="col-lg-6 my-auto order-lg-1 showcase-text">
                <h2>Compare prices and calculate profits</h2>
                <p class="lead mb-0">Build in calculator has been created to approximate re-seller profits or savings.
                </p>
            </div>
        </div>
    </div>
</section>

<footer class="bg-#121212 footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 text-center text-lg-start my-auto h-100">
                <ul class="list-inline mb-2">
                    <li class="list-inline-item"><a [routerLink]="['/about']">About</a></li>
                    <!--
                        <li class="list-inline-item"><span>⋅</span></li>
                        
                        <li class="list-inline-item"><a href="#">Contact</a></li>
                        -->
                    <li class="list-inline-item"><span>⋅</span></li>
                    <li class="list-inline-item"><a [routerLink]="['/terms-of-service']">Terms of &nbsp;Use</a></li>
                    <li class="list-inline-item"><span>⋅</span></li>
                    <li class="list-inline-item"><a [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
                </ul>
                <p class="small mb-4 mb-lg-0">© Av's Emprize 2024. All Rights Reserved.</p>
            </div>
            <div class="col-lg-6 text-center text-lg-end my-auto h-100">
                <ul class="list-inline mb-0">
                    <li class="list-inline-item"><a
                            href="https://www.facebook.com/sharer/sharer.php?u=https%3A//avsemprize.com"><i
                                class="fab fa-facebook fa-2x fa-fw"></i></a></li>
                    <li class="list-inline-item"><a
                            href="http://www.reddit.com/submit?url=https%3A%2F%2Fsendview.io%2Fsocial-media-share-link-generator&title=Price%20Matcher"><i
                                class="fab fa-reddit-alien fa-2x fa-fw"></i></a></li>
                    <li class="list-inline-item"><a
                            href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A//avsemprize.com"><i
                                class="fab fa-linkedin fa-2x fa-fw"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
</footer>